import React, { useMemo, useState } from 'react';
import { FormGroup, Input } from "reactstrap";
import toastr from 'toastr';
import "./Login.css";
import sha1 from 'crypto-js/sha1';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import { buildOktaAuthClient, persistOktaConfig } from "../auth/oktaConfig";
import { ExternalImages } from '../utils/ExternalImages';
import { AuthenticationTypes } from '../utils/AuthenticationTypes';
import { APP_NAME, AuthenticateUrl, AuthenticationTypeWithEmailUrl } from '../constants/apiUrls';
import { Permissions } from './../utils/Permissions';
import appFetch from '../api/appFetch';

export function Login(props) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState({
        value: '',
        show: false
    });
    const [loading, setLoading] = useState(false);

    const { instance } = useMsal();

    const isFormValid = useMemo(()=>{
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        if (password.show) {
            return email.length > 0 && emailRegex.test(email) && password.value.length > 0;
        }

        return email.length > 0 && emailRegex.test(email);
    }, [email, password])

    const onChangeEmail = (email) => {
        if (password.show) {
            setPassword({ value: '', show: false });
        }

        setEmail(email);
    }

    const handleEmailSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        appFetch({
            url: AuthenticationTypeWithEmailUrl(email),
            onSuccess: (data) => {
                switch (data.type) {
                    case AuthenticationTypes.AzureActiveDirectory:
                        instance.loginRedirect(loginRequest).catch(e => {
                            console.log(e);
                        });
                        break;
                    case AuthenticationTypes.Okta:
                        persistOktaConfig(data.oktaIssuer, data.oktaClientId);
                        buildOktaAuthClient({ issuer: data.oktaIssuer, clientId: data.oktaClientId })
                            .signInWithRedirect({ prompt: 'login', loginHint: email })
                            .catch(e => {
                                console.log(e);
                            });
                        break;
                    case AuthenticationTypes.BasicAuthentication:
                        setPassword({ show: true, value: password.value });
                        break;
                    default:
                        break;
                }
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    toastr.error(data.errors[i]);
                }
            },
            onFinalize: () => {
                setLoading(false);
            }
        })
    }

    const handleCredentialsSubmit = (event) => {
        //authenticate
        event.preventDefault();

        setLoading(true);

        appFetch({
            url: AuthenticateUrl(),
            method: 'POST',
            body: JSON.stringify({ username: email, password: password.value, appName: APP_NAME }),
            onSuccess: (data) => {
                const hasRestrictedAccess = data.permissions?.find(
                    (p) => (p.id === Permissions.HasRestrictedDossierAccess)
                  );
                  if (hasRestrictedAccess) {
                    toastr.error("Access denied");
                  } else {
                    var authorizationToken = sha1(
                      data.uniqueKey + "qMymank8Q0rNyJ0RxDXE"
                    );
                    props.loginCallback(
                      data.uniqueKey,
                      authorizationToken.toString()
                    );
                  }
            },
            onError: (data, response) => {
                if(response.status !== 401){
                    for (var i = 0; i < data.errors.length; i++) {
                        toastr.error(data.errors[i]);
                    }
                }
            },
            onFinalize: () => {
                setLoading(false);
            }
        })
    }

    const handleSubmit = (e) => {
        if(password.show){
            return handleCredentialsSubmit(e)
        }

        handleEmailSubmit(e)
    }

    return (
        <div className="Login">
            <div className="text-center">
                <img src={ExternalImages.AutodialogLogo} className="logo" />
            </div>
            <form className="my-4" >
                <FormGroup >
                    <Input type="email" value={email} placeholder="UserName" onChange={e => onChangeEmail(e.target.value)} autoFocus />
                </FormGroup>
                <FormGroup>
                    {password.show && <Input type="password" value={password.value} placeholder="Password" onChange={e => setPassword({ value: e.target.value, show: true })} />}
                </FormGroup>
                <div className="text-center">
                    {loading ? (<CircularProgress />) :
                        (<Button className="login-button" type="submit" variant="contained" color="primary" disabled={!isFormValid} onClick={handleSubmit} >
                            Authenticate
                        </Button>)}
                </div>
            </form>
        </div >
    )
}